import React, { useEffect, useState, useMemo, useRef } from "react";
import "./Dashboard.css";
import axios from "axios";
import { models } from "powerbi-client";
import DashboardRefresh from "./DashboardRefresh";
import { PowerBIEmbed } from "powerbi-client-react";
import ApprovalManagement from "./ApprovalManagement";
import DashboardDownload from "./DashboardDownload";
// import { useActivityLogger } from "../../hooks/useActivityLogger";

const PerformanceReport = ({ reportDetails }) => {
  const reportRef = useRef(null);
  const slicersUpdated = useRef(false);
  const slicersUpdatedCount = useRef(0);

  const [stateFilter, setStateFilter] = useState("All");
  const [facilityFilter, setFacilityFilter] = useState("All");
  const [periodFilter, setPeriodFilter] = useState("All");

  // const { sessionUserBoValue } = useActivityLogger();

  const reportId = 5;

  const [reportInfo, setReportInfo] = useState(null);

  const fetchData = async () => {
    try {
      const response = await axios.post(
        process.env.NODE_ENV === "development"
          ? `http://localhost:9000/mrunner_api/getPowerBIToken`
          : `${window.location.protocol}//${window.location.host}/mrunner_api/getPowerBIToken`,
        { r_id: reportId }
      );
      // console.log("powerBI token", response);
      setReportInfo(response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // console.log("reportDetails", reportDetails);
  // const userEmail = sessionUserBoValue?.email || null; //don't remove ? from here
  const userId = reportDetails?.user_uid || null; //don't remove ? from here

  const embedConfig = useMemo(() => {
    const filters = [];
    // if (userEmail) {
    //   filters.push({
    //     $schema: "http://powerbi.com/product/schema#advanced",
    //     target: {
    //       table: "public dim_userrole_details",
    //       column: "username",
    //     },
    //     operator: "In",
    //     values: [userEmail],
    //   });
    // }
    if (userId) {
      filters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "public dim_userrole_details",
          column: "uid",
        },
        operator: "In",
        values: [userId],
      });
    }
    return {
      type: "report",
      id: reportInfo?.reportId,
      embedUrl: reportInfo?.embedUrl,
      tokenType: models.TokenType.Embed,
      accessToken: reportInfo?.finalToken,
      pageView: "actualSize",
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        layoutType: models.LayoutType.FitToWidth,
      },
      filters,
    };
  }, [reportInfo, userId]);

  const refreshDashboard = () => {
    setReportInfo(null);
    fetchData();
  };

  const getAllFilters = async () => {
    if (!reportRef.current) return;

    try {
      const pages = await reportRef.current.getPages();

      for (const page of pages) {
        const visuals = await page.getVisuals();
        const slicers = visuals.filter((visual) => visual.type === "slicer");
        slicers.forEach(async (slicer) => {
          const slicerState = await slicer.getSlicerState();
          slicerState.filters.forEach((f) => {
            if (f.target.column === "Name of the State") {
              setStateFilter(f.values.join(","));
            }
            if (f.target.column === "Name of the Organization") {
              setFacilityFilter(f.values.join(","));
            }
            if (
              f.target.column === "MonthYear" ||
              f.target.column === "YearMonth"
            ) {
              setPeriodFilter(f.values.join(","));
            }
          });
        });
      }
    } catch (error) {
      console.error("Error getting filters:", error);
    }
  };

  const setSlicers = async () => {
    if (!reportRef.current) return;

    try {
      if (slicersUpdatedCount.current >= 10) {
        slicersUpdated.current = true;
      } else {
        slicersUpdatedCount.current += 1;
      }
      const pages = await reportRef.current.getPages();

      for (const page of pages) {
        const visuals = await page.getVisuals();
        const slicers = visuals.filter((visual) => visual.type === "slicer");

        // console.log("slicers", page, slicers);
        for (const slicer of slicers) {
          try {
            const slicerState = await slicer.getSlicerState();

            // console.log("slicerState", slicer, slicerState);
            // console.log("reportDetails", reportDetails);
            // Determine which slicer we're working with
            const columnName = slicerState?.targets[0]?.column;
            const tableName = slicerState?.targets[0]?.table;

            // console.log("columnName", columnName);
            // console.log("tableName", tableName);
            // Set different values based on the slicer type
            if (columnName === "State" && reportDetails.state !== "All") {
              await slicer.setSlicerState({
                filters: [
                  {
                    $schema: "http://powerbi.com/product/schema#basicFilter",
                    target: {
                      table: tableName,
                      column: columnName,
                    },
                    filterType: 1, // Basic filter
                    operator: "In",
                    values: [reportDetails.state], // Your default values here
                  },
                ],
              });
            } else if (
              columnName === "Facility" &&
              reportDetails.facility !== "All"
            ) {
              await slicer.setSlicerState({
                filters: [
                  {
                    $schema: "http://powerbi.com/product/schema#basicFilter",
                    target: {
                      table: tableName,
                      column: columnName,
                    },
                    filterType: 1,
                    operator: "In",
                    values: [reportDetails.facility], // Your default values here
                  },
                ],
              });
            } else if (
              (columnName === "MonthYear" || columnName === "YearMonth") &&
              reportDetails.period !== "All"
            ) {
              await slicer.setSlicerState({
                filters: [
                  {
                    $schema: "http://powerbi.com/product/schema#basicFilter",
                    target: {
                      table: tableName,
                      column: columnName,
                    },
                    filterType: 1,
                    operator: "In",
                    values: [reportDetails.period], // Your default values here
                  },
                ],
              });
            }
          } catch (e) {
            console.log("error in getting slicer state");
          }
        }
      }
    } catch (error) {
      console.error("Error getting filters:", error);
    }
  };

  return (
    <div
      style={{
        padding: reportDetails ? "0px" : "65px 0px 0px",
        height: "calc(100vh - 64px)",
        width: "100%",
        position: "relative",
      }}
    >
      {reportInfo?.bearerToken && !reportDetails && (
        <div
          className="text-right"
          style={{
            padding: "5px",
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <DashboardRefresh
            reportId={reportId}
            accessToken={reportInfo?.bearerToken}
            groupId={reportInfo?.workspaceId}
            datasetId={reportInfo?.datasetId}
            refreshDashboard={refreshDashboard}
          />

          <ApprovalManagement
            stateFilter={stateFilter}
            periodFilter={periodFilter}
            facilityFilter={facilityFilter}
          />
        </div>
      )}
      <hr />
      {userId && reportDetails?.period && (
        <div
          className="text-right"
          style={{
            padding: "5px",
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <DashboardDownload
            email={userId}
            periodFilter={reportDetails.period}
            type="R2"
          ></DashboardDownload>
        </div>
      )}
      {reportInfo && (
        <PowerBIEmbed
          embedConfig={embedConfig}
          getEmbeddedComponent={(embeddedReport) => {
            reportRef.current = embeddedReport;
          }}
          eventHandlers={
            new Map([
              [
                "loaded",
                function () {
                  if (!reportDetails) {
                    // console.log("Report loaded");
                    getAllFilters();
                  }
                },
              ],
              [
                "rendered",
                function () {
                  if (!reportDetails) {
                    // console.log("Report rendered normal");
                    getAllFilters();
                  }
                  if (reportDetails && !slicersUpdated.current) {
                    // console.log("reportDetails", reportDetails);
                    // console.log("slicersUpdated", slicersUpdated.current);
                    // console.log("Report rendered from approval");
                    setSlicers();
                  }
                },
              ],
              [
                "filtersApplied",
                function () {
                  if (!reportDetails) {
                    // console.log("Filters changed by user normal");
                    getAllFilters();
                  }
                },
              ],
              [
                "error",
                function (event) {
                  console.log("Power BI error:", event.detail);
                },
              ],
            ])
          }
          cssClassName="powerbi-container"
        />
      )}
    </div>
  );
};

export default PerformanceReport;
